import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { AnimationCommon, Breadcrumb } from 'components/common';
import { menuItems, sidebarItems, sidebarItemsConst } from 'constant';

const LayoutNoHeader: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  return (
    <div className={'flex flex-col min-h-screen w-full'}>
      <div className='sticky top-0 z-50'>
        <Breadcrumb menuItems={[...menuItems, sidebarItems, ...sidebarItemsConst]} />
      </div>
      <AnimatePresence mode='wait'>
        <AnimationCommon
          key={location.pathname}
          effect='fadeDown'
          transition='medium'
          duration={0.4}
          delay={0.2}
          disablePresence={true}
          className={'flex-grow w-full h-full bg-[var(--bgGreyColor2)]'}
          fullWidth
          fullHeight
          role='main'
        >
          <Outlet />
          {children}
        </AnimationCommon>
      </AnimatePresence>
    </div>
  );
};

export { LayoutNoHeader };
